import React from 'react';
import { motion } from 'framer-motion';

export function SectionLabel({ children }) {
  return (
    <div className="inline-flex items-center gap-3 text-[11px] tracking-[0.25em] uppercase font-semibold text-[#293891]">
      <span className="w-8 h-[2px] bg-[#E63329]"/>{children}
    </div>
  );
}

export function Reveal({ children, delay=0 }) {
  return (
    <motion.div
      initial={{opacity:0, y:30}}
      whileInView={{opacity:1, y:0}}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration:0.7, delay }}
    >
      {children}
    </motion.div>
  );
}
